import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
	getPropertyExpenses,
	getPropertyExpensesCount,
	getPropertyExpensesList,
	getPropertyExpensesLoading,
	getPropertyExpensesTotal,
} from "state/modules/properties";

import ExpensesList from "./ExpensesList";

interface Props {
	propertyId: string;
}

const PropertyExpensesList = (props: Props): JSX.Element => {
	const { propertyId } = props;

	const dispatch = useDispatch();
	const expenses = useSelector(getPropertyExpensesList);
	const isLoading = useSelector(getPropertyExpensesLoading);
	const count = useSelector(getPropertyExpensesCount);
	const total = useSelector(getPropertyExpensesTotal);

	const hasMore = useMemo(() => count < total, [count, total]);

	const loadMore = () => {
		if (!isLoading) {
			dispatch(getPropertyExpenses(propertyId, true));
		}
	};

	return (
		<ExpensesList
			expenses={expenses}
			isLoading={isLoading}
			hasMore={hasMore}
			loadMore={loadMore}
			scrollableTarget="propertyDetailsListContainer"
		/>
	);
};

export default PropertyExpensesList;
